import Api from '@/services/Api';

export default {
  login(credential) {
    return Api().post('auth/login', credential);
  },
};
